module.exports = __webpack_public_path__ + "static/media/project-team.4704f6b0.svg";